import React, { useState } from 'react'
import PropTypes from 'prop-types'

import { compose } from 'react-apollo'
import Paper from '@material-ui/core/Paper'
import Typography from '@material-ui/core/Typography'
import FormControl from '@material-ui/core/FormControl'
import FormHelperText from '@material-ui/core/FormHelperText'
import TextField from '@material-ui/core/TextField'
import Button from '@material-ui/core/Button'
import InputAdornment from '@material-ui/core/InputAdornment'
import IconButton from '@material-ui/core/IconButton'
import Visibility from '@material-ui/icons/Visibility'
import VisibilityOff from '@material-ui/icons/VisibilityOff'

import { Link } from 'react-router-dom'
import { withFormik } from 'formik'
import * as yup from 'yup'
import { withSnackbar } from 'notistack'

import { isMobile } from '../../utils'
import { styles } from './styles'
import { connect } from 'react-redux'
import { resetHeroPassword } from '../../stores/hero'

const validationSchema = () => {
  /* istanbul ignore next */
  return yup.object().shape({
    newPassword: yup
      .string()
      .required('กรุณากรอกรหัสผ่าน')
      .min(6, 'กรุณากรอกรหัสผ่านอย่างน้อย 6 ตัวอักษร')
  })
}

export const handleSubmit = async (values, { props, setSubmitting }) => {
  const { newPassword } = values
  const { enqueueSnackbar, history, resetHeroPassword, match } = props

  setSubmitting(true)
  const data = {
    token: match.params.token,
    password: newPassword
  }

  await resetHeroPassword(data, enqueueSnackbar)
  setSubmitting(false)
  history.replace('/green2get')
}

export const ResetPassword = ({
  handleSubmit,
  handleChange,
  handleBlur,
  touched,
  errors,
  isSubmitting
}) => {
  const [showPassword, setShowPassword] = useState(false)

  function handleClickShowPassword(e) {
    e.preventDefault()
    setShowPassword(!showPassword)
  }

  return (
    <main style={styles.main}>
      <Paper elevation={isMobile ? 0 : 1} square style={styles.paper}>
        <Typography id="titlePage" variant="h5">
          Set New Password
        </Typography>

        <form onSubmit={handleSubmit}>
          <FormControl
            margin="normal"
            fullWidth
            error={touched.newPassword && Boolean(errors.newPassword)}>
            <TextField
              id="inputNewPassword"
              type={showPassword ? 'text' : 'password'}
              name="newPassword"
              label="New Password"
              onChange={handleChange}
              onBlur={handleBlur}
              error={touched.newPassword && Boolean(errors.newPassword)}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      aria-label="Toggle password visibility"
                      onClick={(e) => handleClickShowPassword(e)}>
                      {showPassword ? <Visibility /> : <VisibilityOff />}
                    </IconButton>
                  </InputAdornment>
                )
              }}
            />
            {touched.newPassword && errors.newPassword && (
              <FormHelperText>{errors.newPassword}</FormHelperText>
            )}
          </FormControl>
          {isSubmitting ? (
            <Button disabled fullWidth style={styles.button}>
              Reset Password...
            </Button>
          ) : (
            <Button
              variant="contained"
              id="btnSubmit"
              type="submit"
              color="primary"
              fullWidth
              style={styles.button}>
              Set Password
            </Button>
          )}
        </form>
      </Paper>
      {/* <div
        style={{
          marginTop: '1em'
        }}>
        <Button id="btnLogin" color="primary" fullWidth>
          <Link href="#" to="/" style={styles.link}>
            Login
          </Link>
        </Button>
      </div> */}
    </main>
  )
}

ResetPassword.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  handleChange: PropTypes.func.isRequired,
  handleBlur: PropTypes.func.isRequired,
  errors: PropTypes.object.isRequired,
  touched: PropTypes.object.isRequired,
  isSubmitting: PropTypes.bool.isRequired
}

const mapDispatchToProps = {
  resetHeroPassword
}

export default compose(
  withSnackbar,
  connect(null, mapDispatchToProps),
  withFormik({
    enableReinitialize: true,
    handleSubmit,
    validationSchema,
    displayName: 'ResetPasswordForm'
  })
)(ResetPassword)



// WEBPACK FOOTER //
// ./src/pages/ResetPassword/index.js